import api from '@/client/core/api'
import { PostInstagramInstantwinPrizeCopyResponse } from '@/typings/api/instagram_instantwin_prizes.schema'

type PostInstagramInstantwinPrizeCopyErrorResponse = {
  error: {
    status: number
    type: string
    message: string
  }
}

export type PostInstagramInstantwinPrizeCopyApiResponse =
  | PostInstagramInstantwinPrizeCopyResponse
  | PostInstagramInstantwinPrizeCopyErrorResponse

/**
 * Instagram インスタントウィン応募グループを複製
 *
 * @param prizeId - 複製対象の応募グループID
 * @returns 成功時は `data: true`、失敗時は `error`
 */
export async function postInstagramInstantwinPrizeCopy(
  prizeId: number
): Promise<PostInstagramInstantwinPrizeCopyApiResponse> {
  return await api.post<PostInstagramInstantwinPrizeCopyApiResponse>(`/instagram_instantwin_prizes/${prizeId}/copy`, {})
}
